/* sst-pdp.js - Shopify PDP interactions.
   Colour choices are code-driven line-item properties only, not variants. */

(function () {
  'use strict';

  function initInstance(root) {
    if (!root || root.dataset.sstPdpInit === '1') return;
    root.dataset.sstPdpInit = '1';

    var sectionId = root.dataset.sectionId;
    var dataEl = document.getElementById('sst-pdp-data-' + sectionId)
      || root.querySelector('script[type="application/json"]');
    var productData;
    try {
      productData = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    } catch (e) {
      productData = { variants: [] };
    }

    var bundlePosition = Number(root.dataset.bundlePosition || 0) - 1;
    var variants = Array.isArray(productData.variants) ? productData.variants : [];
    var bOpts = Array.prototype.slice.call(root.querySelectorAll('.sst-pdp__bopt'));
    var colorbox = root.querySelector('.sst-pdp__colorbox');
    var views = Array.prototype.slice.call(root.querySelectorAll('.sst-pdp__gal-view'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.sst-pdp__thumb'));
    var galMain = root.querySelector('.sst-pdp__gal-main');
    var thumbsRail = root.querySelector('.sst-pdp__thumbs');
    var galArrows = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-action]'));
    var thumbArrows = Array.prototype.slice.call(root.querySelectorAll('[data-thumb-action]'));
    var comboView = root.querySelector('.sst-pdp__combo-view');
    var comboSlots = comboView ? Array.prototype.slice.call(comboView.querySelectorAll('[data-combo-pot]')) : [];
    var comboStage = comboView ? comboView.querySelector('.sst-pdp__combo-stage') : null;
    var comboCap = comboView ? comboView.querySelector('.sst-pdp__combo-cap') : null;
    var potImageMap = {
      white: root.dataset.potWhite || '',
      blue: root.dataset.potBlue || '',
      yellow: root.dataset.potYellow || ''
    };

    var priceNumEl = root.querySelector('.sst-pdp__price-num');
    var pricePrefixEl = root.querySelector('.sst-pdp__price-prefix');
    var wasEl = root.querySelector('.sst-pdp__wasprice');
    var saveEl = root.querySelector('.sst-pdp__savepill');
    var ctaEl = root.querySelector('.sst-pdp__cta-main');
    var stickyBar = root.querySelector('.sst-pdp__stickybar');
    var stickyCtaEl = root.querySelector('.sst-pdp__stickybar-cta');
    var stickyPriceEl = root.querySelector('.sst-pdp__stickybar-price');

    var colourConfigs = readColourConfigs();
    var requestedBundleQty = '';
    var requestedBundle = '';
    try {
      var params = new URLSearchParams(window.location.search);
      requestedBundleQty = params.get('bundle_qty') || params.get('bundleQty') || '';
      requestedBundle = params.get('bundle') || '';
    } catch (e) {
      requestedBundleQty = '';
      requestedBundle = '';
    }
    var initialBundle = bOpts.filter(function (b) {
      return requestedBundleQty && b.dataset.qty === requestedBundleQty;
    })[0] || bOpts.filter(function (b) {
      return requestedBundle && b.dataset.bundle === requestedBundle;
    })[0] || bOpts.filter(function (b) { return b.classList.contains('is-selected'); })[0]
      || bOpts[bOpts.length - 1];
    var selectedBundle = initialBundle ? initialBundle.dataset.bundle : '';
    var selectedQty = initialBundle ? Number(initialBundle.dataset.qty || 1) : 3;
    var selectedColours = colourConfigs.slice(0, selectedQty).map(function (c) { return c.value; });
    while (selectedColours.length < selectedQty && colourConfigs.length) {
      selectedColours.push(colourConfigs[selectedColours.length % colourConfigs.length].value);
    }
    var comboReady = false;

    function readColourConfigs() {
      if (!colorbox) return [];
      try {
        var parsed = JSON.parse(colorbox.dataset.colours || '[]');
        return parsed.map(function (item) {
          return {
            label: item.label || item.value,
            value: item.value || item.label,
            slug: item.slug || slugifyColour(item.value || item.label),
            cls: item.cls || 'white',
            swatch: item.swatch || '',
            focalPoint: item.focalPoint || ''
          };
        });
      } catch (e) {
        return [];
      }
    }

    function centsToNumber(c) { return Number(c || 0) / 100; }
    function fmtCents(c) { return centsToNumber(c).toLocaleString('en-PK', { maximumFractionDigits: 0 }); }
    function money(c) { return 'Rs. ' + fmtCents(c); }
    function slugifyColour(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/&amp;/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
    function titleCaseSlug(value) {
      return String(value || '').split('-').map(function (part) {
        return part ? part.charAt(0).toUpperCase() + part.slice(1) : '';
      }).join(' ');
    }
    function variantOption(variant, idx) {
      if (!variant || idx < 0) return '';
      return variant.options ? variant.options[idx] : variant['option' + (idx + 1)];
    }
    function variantMatchesBundle(variant, bundle) {
      if (!bundle || bundlePosition < 0) return true;
      return variantOption(variant, bundlePosition) === bundle;
    }
    function findVariant(bundle) {
      return variants.filter(function (v) { return v.available && variantMatchesBundle(v, bundle); })[0]
        || variants.filter(function (v) { return variantMatchesBundle(v, bundle); })[0]
        || variants.filter(function (v) { return v.available; })[0]
        || variants[0]
        || null;
    }
    function selectedColourConfig(colour) {
      return colourConfigs.filter(function (item) { return item.value === colour; })[0];
    }
    function selectedComboSlugs() {
      return selectedColours.slice(0, selectedQty).map(function (colour) {
        var config = colourConfigs.filter(function (item) { return item.value === colour; })[0];
        return config ? config.slug : slugifyColour(colour);
      });
    }
    function selectedComboLabel() {
      var parts = selectedColours.slice(0, selectedQty).map(function (colour) {
        var config = selectedColourConfig(colour);
        return config ? config.label : titleCaseSlug(slugifyColour(colour));
      }).filter(Boolean);
      return parts.length ? parts.join(' + ') : '';
    }
    function selectedVariant() {
      var byBundle = findVariant(selectedBundle);
      if (byBundle) return byBundle;
      var variantId = Number(root.dataset.variantId || 0);
      var fromData = variants.filter(function (v) { return Number(v.id) === variantId; })[0];
      return fromData || {
        id: variantId,
        available: root.dataset.variantAvailable !== 'false',
        price: Number(root.dataset.variantPrice || 0),
        compare_at_price: Number(root.dataset.variantCompare || 0)
      };
    }

    /* ---- gallery ---- */
    function availableViews() {
      return views.filter(function (view) {
        return comboReady || view.dataset.view !== 'combo-image';
      });
    }
    function currentViewIndex(keys) {
      var active = views.filter(function (v) { return v.classList.contains('sst-pdp--on'); })[0];
      var index = active ? keys.indexOf(active.dataset.view) : 0;
      return index >= 0 ? index : 0;
    }
    function hydrateImage(img) {
      if (!img) return;
      var src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }
    }
    function hydrateMediaForView(key) {
      var view = views.filter(function (item) { return item.dataset.view === key; })[0];
      if (view) Array.prototype.forEach.call(view.querySelectorAll('img[data-src], img[data-srcset]'), hydrateImage);
      thumbs.forEach(function (thumb) {
        if (thumb.dataset.show === key) hydrateImage(thumb.querySelector('img[data-src]'));
      });
    }
    function hydrateThumbsOnIdle() {
      var load = function () {
        thumbs.forEach(function (thumb) { hydrateImage(thumb.querySelector('img[data-src]')); });
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(load, { timeout: 2200 });
      } else {
        window.setTimeout(load, 1400);
      }
    }
    function showView(key) {
      if (!key) return;
      hydrateMediaForView(key);
      if (galMain) galMain.classList.toggle('is-combo-image', key === 'combo-image');
      views.forEach(function (v) { v.classList.toggle('sst-pdp--on', v.dataset.view === key); });
      thumbs.forEach(function (t) {
        var on = t.dataset.show === key;
        t.classList.toggle('sst-pdp--on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && t.scrollIntoView) {
          t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
    }
    function moveGallery(step) {
      var keys = availableViews().map(function (v) { return v.dataset.view; });
      if (!keys.length) return;
      var next = (currentViewIndex(keys) + step + keys.length) % keys.length;
      showView(keys[next]);
    }
    function showComboImage() {
      if (!comboSlots.length || !comboView) return false;
      var slugs = selectedComboSlugs();
      var canRender = slugs.every(function (slug) { return potImageMap[slug]; });
      if (!canRender) return false;
      var label = selectedComboLabel();
      var slotSources = selectedQty === 1
        ? [null, 0, null]
        : selectedQty === 2
          ? [0, null, 1]
          : [0, 1, 2];

      comboReady = true;
      if (comboStage) comboStage.dataset.qty = String(selectedQty);
      comboSlots.forEach(function (img, index) {
        var sourceIndex = slotSources[index];
        if (sourceIndex === null || typeof sourceIndex === 'undefined' || sourceIndex >= selectedQty) {
          img.hidden = true;
          img.classList.add('is-hidden');
          img.setAttribute('aria-hidden', 'true');
          img.removeAttribute('src');
          img.removeAttribute('srcset');
          return;
        }

        var slug = slugs[sourceIndex] || slugs[0];
        var url = potImageMap[slug];
        img.hidden = false;
        img.classList.remove('is-hidden');
        img.setAttribute('aria-hidden', 'false');
        if (url && img.getAttribute('src') !== url) img.src = url;
      });
      if (comboStage) comboStage.setAttribute('aria-label', label || root.dataset.product || '');
      if (comboCap) comboCap.textContent = label || root.dataset.product || '';
      showView(comboView.dataset.view);
      return true;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showView(thumb.dataset.show); });
    });
    galArrows.forEach(function (button) {
      button.addEventListener('click', function () {
        moveGallery(button.dataset.galleryAction === 'prev' ? -1 : 1);
      });
    });
    thumbArrows.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!thumbsRail) return;
        var dir = button.dataset.thumbAction === 'prev' ? -1 : 1;
        thumbsRail.scrollBy({ left: dir * thumbsRail.clientWidth, behavior: 'smooth' });
      });
    });
    if (galMain && views.length > 1) {
      var dragStartX = 0;
      var isDragging = false;
      function slideBy(deltaX) {
        if (Math.abs(deltaX) < 40) return;
        moveGallery(deltaX < 0 ? 1 : -1);
      }
      galMain.addEventListener('mousedown', function (e) { isDragging = true; dragStartX = e.clientX; });
      galMain.addEventListener('mousemove', function (e) { if (isDragging) e.preventDefault(); });
      galMain.addEventListener('mouseup', function (e) { if (!isDragging) return; isDragging = false; slideBy(e.clientX - dragStartX); });
      galMain.addEventListener('mouseleave', function () { isDragging = false; });
      galMain.addEventListener('touchstart', function (e) { dragStartX = e.touches[0].clientX; }, { passive: true });
      galMain.addEventListener('touchend', function (e) { slideBy(e.changedTouches[0].clientX - dragStartX); });
    }
    if (thumbsRail) {
      var railStartX = 0;
      var railScrollLeft = 0;
      var railDragging = false;
      thumbsRail.addEventListener('mousedown', function (e) {
        railDragging = true;
        railStartX = e.clientX;
        railScrollLeft = thumbsRail.scrollLeft;
      });
      thumbsRail.addEventListener('mousemove', function (e) {
        if (!railDragging) return;
        e.preventDefault();
        thumbsRail.scrollLeft = railScrollLeft - (e.clientX - railStartX);
      });
      thumbsRail.addEventListener('mouseup', function () { railDragging = false; });
      thumbsRail.addEventListener('mouseleave', function () { railDragging = false; });
    }

    function setTextAndDisplay(el, text) {
      if (!el) return;
      el.textContent = text || '';
      el.style.display = text ? '' : 'none';
    }
    function renderColours() {
      if (!colorbox) return;
      colorbox.innerHTML = '';
      for (var i = 0; i < selectedQty; i += 1) {
        (function (idx) {
          var row = document.createElement('div');
          row.className = 'sst-pdp__crow';
          var selectedConfig = colourConfigs.filter(function (c) { return c.value === selectedColours[idx]; })[0] || colourConfigs[0];
          var label = document.createElement('div');
          label.className = 'sst-pdp__clab';
          label.textContent = 'Pot ' + (idx + 1);
          var small = document.createElement('small');
          small.textContent = selectedConfig ? selectedConfig.label : '';
          label.appendChild(small);
          var swatches = document.createElement('div');
          swatches.className = 'sst-pdp__swatches';
          colourConfigs.forEach(function (config) {
            var swatch = document.createElement('button');
            var isSelected = selectedColours[idx] === config.value;
            swatch.type = 'button';
            swatch.className = 'sst-pdp__sw sst-pdp__sw--' + config.cls;
            swatch.setAttribute('aria-label', 'Choose ' + config.label + ' for Pot ' + (idx + 1));
            if (config.swatch) {
              swatch.style.background = config.swatch;
              if (config.focalPoint) swatch.style.backgroundPosition = config.focalPoint;
              swatch.style.backgroundSize = 'cover';
            }
            swatch.setAttribute('aria-checked', isSelected ? 'true' : 'false');
            swatch.classList.toggle('is-selected', isSelected);
            swatch.addEventListener('click', function () {
              selectedColours[idx] = config.value;
              renderColours();
              renderCta();
              showComboImage();
            });
            swatches.appendChild(swatch);
          });
          row.appendChild(label);
          row.appendChild(swatches);
          colorbox.appendChild(row);
        })(i);
      }
    }
    function renderPrice() {
      var variant = selectedVariant();
      if (!variant) return;
      if (pricePrefixEl) pricePrefixEl.textContent = 'Set of ' + selectedQty + (selectedQty === 1 ? ' Pot' : ' Pots') + ' only for Rs.';
      if (priceNumEl) priceNumEl.textContent = fmtCents(variant.price);
      if (stickyPriceEl) stickyPriceEl.textContent = money(variant.price);
      if (Number(variant.compare_at_price) > Number(variant.price)) {
        setTextAndDisplay(wasEl, money(variant.compare_at_price));
        setTextAndDisplay(saveEl, 'You save ' + money(Number(variant.compare_at_price) - Number(variant.price)));
      } else {
        setTextAndDisplay(wasEl, '');
        setTextAndDisplay(saveEl, '');
      }
    }
    function renderCta() {
      var variant = selectedVariant();
      if (!variant) return;
      [ctaEl, stickyCtaEl].forEach(function (button) {
        if (!button) return;
        button.dataset.variantId = variant.id;
        button.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      });
    }
    function updateBundleCards() {
      bOpts.forEach(function (button) {
        var variant = findVariant(button.dataset.bundle);
        if (!variant) return;
        button.dataset.variantId = variant.id;
        button.dataset.priceCents = variant.price;
        button.dataset.compareCents = variant.compare_at_price || 0;

        var qty = Number(button.dataset.qty || 1);
        var eachEl = button.querySelector('.sst-pdp__beach');
        var priceEl = button.querySelector('.sst-pdp__bprice');
        if (eachEl) eachEl.textContent = money(Math.round(Number(variant.price || 0) / qty)) + ' each';
        if (priceEl) {
          priceEl.textContent = '';
          priceEl.appendChild(document.createTextNode(money(variant.price)));
          if (Number(variant.compare_at_price) > Number(variant.price)) {
            var was = document.createElement('span');
            was.className = 'sst-pdp__bwas';
            was.textContent = money(variant.compare_at_price);
            priceEl.appendChild(document.createTextNode(' '));
            priceEl.appendChild(was);
          }
        }
      });
    }
    function selectedLineItemProperties() {
      var properties = {};
      if (selectedBundle) properties.Bundle = selectedBundle;
      selectedColours.slice(0, selectedQty).forEach(function (colour, index) {
        var config = colourConfigs.filter(function (item) { return item.value === colour; })[0];
        properties['Pot ' + (index + 1)] = config ? config.label : colour;
      });
      return properties;
    }
    function addSelectedVariantToCart(event) {
      var clickedCta = event.currentTarget || ctaEl;
      var variant = selectedVariant();
      if (!variant || !variant.available) {
        if (event) event.preventDefault();
        return;
      }
      if (event) event.preventDefault();
      var originalText = clickedCta.textContent;
      clickedCta.textContent = 'Going to checkout...';
      clickedCta.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variant.id), quantity: 1, properties: selectedLineItemProperties() }]
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function () {
        window.location.href = '/cart';
      }).then(function () {
        clickedCta.textContent = originalText;
        clickedCta.removeAttribute('aria-busy');
      });
    }
    function updateStickyBar() {
      if (!stickyBar) return;
      var shouldShow = window.scrollY > 420;
      stickyBar.classList.toggle('is-visible', shouldShow);
      toggleWhatsappLaunchers(shouldShow);
    }
    function selectBundle(bundle, revealCombo) {
      var selectedButton = bOpts.filter(function (button) { return button.dataset.bundle === bundle; })[0] || bOpts[0];
      if (!selectedButton) return;
      selectedBundle = selectedButton.dataset.bundle;
      selectedQty = Number(selectedButton.dataset.qty || 1);
      bOpts.forEach(function (button) {
        var on = button === selectedButton;
        button.classList.toggle('is-selected', on);
        button.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      while (selectedColours.length > selectedQty) selectedColours.pop();
      while (selectedColours.length < selectedQty) {
        var next = colourConfigs[selectedColours.length % Math.max(colourConfigs.length, 1)];
        selectedColours.push(next ? next.value : '');
      }
      updateBundleCards();
      renderColours();
      renderPrice();
      renderCta();
      if (revealCombo) showComboImage();
    }
    function whatsappCandidates() {
      var selector = [
        'a[href*="wa.me"]',
        'a[href*="api.whatsapp.com"]',
        'a[href*="whatsapp"]',
        '[class*="whatsapp" i]',
        '[id*="whatsapp" i]',
        '[aria-label*="whatsapp" i]',
        '[title*="whatsapp" i]'
      ].join(',');
      try {
        return Array.prototype.slice.call(document.body.querySelectorAll(selector));
      } catch (e) {
        return Array.prototype.slice.call(document.body.querySelectorAll('a[href*="whatsapp"], a[href*="wa.me"]'));
      }
    }
    function whatsappLauncherNode(el) {
      var node = el;
      for (var i = 0; node && node !== document.body && i < 5; i += 1, node = node.parentElement) {
        var style = window.getComputedStyle(node);
        var rect = node.getBoundingClientRect();
        var fixedNearBottom = (style.position === 'fixed' || style.position === 'sticky')
          && rect.bottom > window.innerHeight - 180;
        if (fixedNearBottom) return node;
      }
      return el;
    }
    function toggleWhatsappLaunchers(show) {
      whatsappCandidates().forEach(function (el) {
        if (root.contains(el) || (stickyBar && stickyBar.contains(el))) return;
        var launcher = whatsappLauncherNode(el);
        if (!launcher || root.contains(launcher)) return;
        if (!launcher.dataset.sstWhatsappOriginalDisplay) {
          launcher.dataset.sstWhatsappOriginalDisplay = launcher.style.display || '__empty__';
        }
        if (show) {
          if (launcher.dataset.sstWhatsappOriginalDisplay === '__empty__') {
            launcher.style.removeProperty('display');
          } else {
            launcher.style.setProperty('display', launcher.dataset.sstWhatsappOriginalDisplay, 'important');
          }
        } else {
          launcher.style.setProperty('display', 'none', 'important');
        }
        launcher.setAttribute('data-sst-whatsapp-scroll-toggle', 'true');
      });
    }
    function suppressDuplicateStickyCtas() {
      if (!stickyBar) return;
      var candidates = Array.prototype.slice.call(document.body.querySelectorAll('a, button, [role="button"]'));
      candidates.forEach(function (el) {
        if (stickyBar.contains(el) || root.contains(el)) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!/order now|cash on delivery|add to cart/.test(text)) return;
        var node = el;
        for (var i = 0; node && node !== document.body && i < 5; i += 1, node = node.parentElement) {
          var style = window.getComputedStyle(node);
          var rect = node.getBoundingClientRect();
          var nearBottom = rect.bottom > window.innerHeight - 140;
          if ((style.position === 'fixed' || style.position === 'sticky') && nearBottom) {
            node.style.setProperty('display', 'none', 'important');
            node.setAttribute('data-sst-hidden-duplicate-sticky', 'true');
            break;
          }
        }
      });
    }

    if (ctaEl) ctaEl.addEventListener('click', addSelectedVariantToCart);
    if (stickyCtaEl) stickyCtaEl.addEventListener('click', addSelectedVariantToCart);
    bOpts.forEach(function (button) {
      button.addEventListener('click', function () { selectBundle(button.dataset.bundle, true); });
    });
    window.addEventListener('scroll', function () {
      updateStickyBar();
      suppressDuplicateStickyCtas();
    }, { passive: true });
    window.addEventListener('resize', function () {
      updateStickyBar();
      suppressDuplicateStickyCtas();
    });

    updateBundleCards();
    if (bOpts.length) {
      selectBundle(selectedBundle, false);
    } else {
      renderColours();
      renderPrice();
      renderCta();
    }
    updateStickyBar();
    suppressDuplicateStickyCtas();
    toggleWhatsappLaunchers(false);
    window.setTimeout(suppressDuplicateStickyCtas, 600);
    window.setTimeout(suppressDuplicateStickyCtas, 1600);
    window.setTimeout(updateStickyBar, 600);
    window.setTimeout(updateStickyBar, 1600);
    hydrateThumbsOnIdle();
  }

  function initAll() {
    var legacy = document.getElementById('sst-pdp-root');
    if (legacy) initInstance(legacy);
    var nodes = document.querySelectorAll('.sst-pdp[data-section-id]');
    Array.prototype.forEach.call(nodes, function (node) { initInstance(node); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
